import { createApiHook, useApi } from "../utils/apiUtils";

const useDeleteAnswerOption = () => {
  const { apiDelete } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const deleteAnswerOption = async (id) => {
    startLoading();
    const res = await apiDelete(`/answer_options/${id}`, "Error al eliminar la opción de respuesta");
    setResponse(res);

    if (res?.error) {
      const err = new Error(res.error.message || "No se pudo eliminar la opción de respuesta");
      err.backend = res.error;
      throw err;
    }
    return res;
  };

  return { deleteAnswerOption, data, loading, error };
};

export default useDeleteAnswerOption;
